import {
  hideBackButton,
  initDataUser,
  isMiniAppDark,
  onBackButtonClick,
  showBackButton,
  useSignal,
} from '@telegram-apps/sdk-react'
import { useEffect } from 'react'

/** Telegram user from init data. Display only: never trust it for authorization on the client. */
export function useTelegramUser() {
  return useSignal(initDataUser)
}

export function useIsTelegramDark(): boolean {
  return useSignal(isMiniAppDark)
}

/**
 * Shows the native Telegram back button while `isVisible` is true.
 * `onBack` must be stable (wrap it in `useCallback`), otherwise the listener re-binds every render.
 */
export function useTelegramBackButton(isVisible: boolean, onBack: () => void): void {
  useEffect(() => {
    if (!isVisible || !showBackButton.isAvailable()) {
      hideBackButton.ifAvailable()
      return
    }
    showBackButton()
    const removeClickListener = onBackButtonClick(onBack)
    return () => {
      removeClickListener()
      hideBackButton.ifAvailable()
    }
  }, [isVisible, onBack])
}
